import React , {useState}from "react";

import Grid2 from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import Button from "@mui/material/Button";
import MessageOutlinedIcon from "@mui/icons-material/MessageOutlined";
import SvgIconStyle from "../../../components/SvgIconStyle";
import { ComponentType } from "../../../common/enum";
import {
  Grid, GridColumn as Column
} from '@progress/kendo-react-grid';
import { process } from "@progress/kendo-data-query";
import  {ColumnMenu}  from './CostumeFilterUI';
import { GridColumnMenuFilter } from '@progress/kendo-react-grid';
import { IntlProvider, load, LocalizationProvider, loadMessages } from '@progress/kendo-react-intl';
import esMessages from './tlklang.json';


const DonationDetail = ({
  id,
  donationType,
  dataInicio,
  dataFim,
  reserva,
  componentType,
  t,
  all,
  handleClick,
  handleMessageClick,
  donationStatus,
}) => {
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down("md"));
  const fontWeightStyle =
    componentType === ComponentType.DONATION_HEADER ? "600" : "normal";
  const colorStyle =
    componentType === ComponentType.DONATION_HEADER
      ? "text.primary"
      : "text.secondary";
      
      const GRIDCOLUMNS = [
        { field: 'id', title: 'ID' },
        { field: 'donationType', title: 'Donation Type' },
        { field: 'periodo', title: 'Period' },
        { field: 'reserva', title: 'Reserva' }
      ];
      const createDataState = dataState => {
        return {
          result: all != undefined ?   process(all.slice(0), dataState) : 0,
          dataState: dataState,
        };
      };
      
      
      loadMessages(esMessages, 'pt-PT');

      let initialState = createDataState({
        take: 8,
        skip: 0,
      });
      const [result, setResult] = React.useState(initialState.result);
      const [dataState, setDataState] = React.useState(initialState.dataState);
      const dataStateChange = event => {
        let updatedState = createDataState(event.dataState);
        setResult(updatedState.result);
        setDataState(updatedState.dataState);
      };

      const CustomButtonCell = (props) => {
        const { dataItem } = props;
        return (
          <td  style={props.style} // this applies styles that lock the column at a specific position
          className={props.className + ' gridButtons'} // this adds classes needed for locked columns
          colSpan={props.colSpan}
          role={"gridcell"}
          aria-colindex={props.ariaColumnIndex}
          aria-selected={props.isSelected}>
          
       <Button
          sx={{
            bgcolor: "#E1EFB0",
            width: "36px",
            height: "36px",
            minWidth: 0,
            borderRadius: '4px'
          }}
          size="small"
          onClick={() => handleClick(dataItem)}
        >
          <SvgIconStyle
            src="/static/dashboard/info.svg"
            sx={{ color: "black", width: "16px", height: "16px" }}
          />
        </Button>
          </td>
        );
      };
      const CustomButtonCell2 = (props) => {
        const { dataItem } = props;
        if(dataItem.mensagens == 'tem'){
          return (
            <td 
            style={props.style} // this applies styles that lock the column at a specific position
            className={props.className + ' gridButtons buttonmessage'} // this adds classes needed for locked columns
            colSpan={props.colSpan}

            role={"gridcell"}
            aria-colindex={props.ariaColumnIndex}
            aria-selected={props.isSelected}
           >
             {dataItem.reserva > 0 &&
           <Button
           sx={{
             mr: 1,
             width: "36px",
             height: "36px",
             minWidth: 0,
             borderRadius:'4px'
           }}
           onClick={(event) => handleMessageClick(event , dataItem)}
         >
  
           <MessageOutlinedIcon />
         </Button>}
         
            </td>
          );
        }else{
          return (
            <td 
            style={props.style} // this applies styles that lock the column at a specific position
            className={props.className + ' gridButtons buttonmessage'} // this adds classes needed for locked columns
            colSpan={props.colSpan}
            role={"gridcell"}
            aria-colindex={props.ariaColumnIndex}
            aria-selected={props.isSelected}
           >
           
         
            </td>
          );
        }
        
      };
      // const renderCustomButton = (props) => (
      //   var  dataItem  = props;
      //   <td>
      //  {row.reserva > 0 &&
      //    <Button
      //    sx={{
      //      mr: 1,
      //      width: "36px",
      //      height: "36px",
      //      minWidth: 0,
      //      borderRadius:'4px'
      //    }}
      //    onClick={(event) => handleMessageClick(event , row)}
      //  >

      //    <MessageOutlinedIcon />
      //  </Button>}
      //  <Button
      //     sx={{
      //       bgcolor: "#E1EFB0",
      //       width: "36px",
      //       height: "36px",
      //       minWidth: 0,
      //       borderRadius: '4px'
      //     }}
      //     size="small"
      //     onClick={() => handleClick(row)}
      //   >
      //     <SvgIconStyle
      //       src="/static/dashboard/info.svg"
      //       sx={{ color: "black", width: "16px", height: "16px" }}
      //     />
      //   </Button>
      //   </td>
       
      // );
const renderCustomButtonSemMensagem = (row) => (
        <div>
       
       <Button
          sx={{
            bgcolor: "#E1EFB0",
            width: "36px",
            height: "36px",
            minWidth: 0,
            borderRadius: '4px'
          }}
          size="small"
          onClick={() => handleClick(row)}
        >
          <SvgIconStyle
            src="/static/dashboard/info.svg"
            sx={{ color: "black", width: "16px", height: "16px" }}
          />
        </Button>
        </div>
       
      );
      const MyColumnMenu = (props) => <ColumnMenu {...props} data={all}/>
      const totalWidth = 100; // Total width of the container in percentage

      const getColumnWidth = (width) => {
        return (width / totalWidth) * 100 + "%";
      };
     ////// colunas dinamicas /////
     const columnsGrid = React.useMemo(() => {
      var columns = [];
      
      if(donationStatus === 'NEW' && $(".tab1Estado").text() == 'Sem reservas canal alternativo'){
        columns.push(
          
          <Column field="id" title="ID" locked={true} width={getColumnWidth(200)} filter={'numeric'} columnMenu={MyColumnMenu} />,
          <Column field="donationType" title="Tipo" width={getColumnWidth(300)} columnMenu={MyColumnMenu} />,
          <Column title="Período">
            <Column field="dataInicio" title="Data início" width={getColumnWidth(300)} filter={'date'} columnMenu={MyColumnMenu} />,
            <Column field="dataFim" title="Data final" width={getColumnWidth(300)} filter={'date'} columnMenu={MyColumnMenu} />
          </Column>,
          <Column title="Período canal alternativo">
            <Column field="dataInicioCanalAlternativo" title="Data início" width={getColumnWidth(300)} filter={'date'} columnMenu={MyColumnMenu} />,
            <Column field="dataFinalCanalAlternativo" title="Data final" width={getColumnWidth(300)} filter={'date'} columnMenu={MyColumnMenu} />
        </Column>,
         <Column cell={CustomButtonCell2} locked={true} width={getColumnWidth(70)}/>,
         <Column cell={CustomButtonCell}  locked={true} width={getColumnWidth(70)}/>
          // <Column
          //   title="Ações"
          //   cell={(props) => renderCustomButton(props.dataItem)}
          //   width={getColumnWidth(100)}
          // />
        );
      }else if(donationStatus === 'RESERVATION' && all != undefined && all.length > 0 &&  all[0].isAnimal){
        columns.push(
        
          <Column field="id" title="ID" locked={true} width={getColumnWidth(150)} filter={'numeric'} columnMenu={MyColumnMenu} />,
          <Column field="donationType" title="Tipo" width={getColumnWidth(300)} columnMenu={MyColumnMenu} />,
          <Column title="Período">
            <Column field="dataInicio" title="Data início" width={getColumnWidth(300)} filter={'date'} columnMenu={MyColumnMenu} />,
            <Column field="dataFim" title="Data final" width={getColumnWidth(300)} filter={'date'} columnMenu={MyColumnMenu} />
          </Column>,
          <Column title="Período canal alternativo">
            <Column field="dataInicioCanalAlternativo" title="Data início" width={getColumnWidth(300)} filter={'date'} columnMenu={MyColumnMenu} />,
            <Column field="dataFinalCanalAlternativo" title="Data final" width={getColumnWidth(300)} filter={'date'} columnMenu={MyColumnMenu} />
        </Column>,
          <Column title="Reservas">
          <Column field="reserva" title="Nº" width={getColumnWidth(150)} columnMenu={MyColumnMenu} />,
          <Column field="status" title="Estado" width={getColumnWidth(150)} columnMenu={MyColumnMenu} />,
        </Column>,
         <Column cell={CustomButtonCell2} locked={true} width={getColumnWidth(70)}/>,
         <Column cell={CustomButtonCell}  locked={true} width={getColumnWidth(70)}/>
          // <Column
          //   title="Ações"
          //   cell={(props) => renderCustomButton(props.dataItem)}
          //   width={getColumnWidth(100)}
          // />
        );
      }else if (donationStatus === 'NEW' && $(".tab1Estado").text() == 'Sem reservas') {
        columns.push(
          <Column field="id" title="ID" locked={true} width={getColumnWidth(120)} filter={'numeric'} columnMenu={MyColumnMenu} />,
          <Column field="donationType" title="Tipo" width={getColumnWidth(200)} columnMenu={MyColumnMenu} />,
          <Column title="Período">
            <Column field="dataInicio" title="Data início" width={getColumnWidth(260)} filter={'date'} columnMenu={MyColumnMenu} />,
            <Column field="dataFim" title="Data final" width={getColumnWidth(260)} filter={'date'} columnMenu={MyColumnMenu} />
          </Column>,
        
         <Column cell={CustomButtonCell}  locked={true} width={getColumnWidth(70)}/>
          // <Column
          //   title="Ações"
          //   locked={true}
          //   cell={(props) => renderCustomButton(props.dataItem)}
            
          //   width={getColumnWidth(100)}
          // />
        );
      }else if(donationStatus === 'RESERVATION'){
        columns.push(
          <Column field="id" title="ID" locked={true} width={getColumnWidth(120)} filter={'numeric'} columnMenu={MyColumnMenu} />,
          <Column field="donationType" title="Tipo" width={getColumnWidth(200)} columnMenu={MyColumnMenu} />,
          <Column title="Período">
            <Column field="dataInicio" title="Data início" width={getColumnWidth(200)} filter={'date'} columnMenu={MyColumnMenu} />,
            <Column field="dataFim" title="Data final" width={getColumnWidth(200)} filter={'date'} columnMenu={MyColumnMenu} />
          </Column>,
          <Column title="Reservas">
            <Column field="reserva" title="Nº" width={getColumnWidth(150)} columnMenu={MyColumnMenu} />,
            <Column field="status" title="Estado" width={getColumnWidth(150)} columnMenu={MyColumnMenu} />,
          </Column>,
           <Column cell={CustomButtonCell2} locked={true} width={getColumnWidth(70)}/>,
           <Column cell={CustomButtonCell}  locked={true} width={getColumnWidth(70)}/>
          
          // <Column
          //   title="Ações"
          //   locked={true}
          //   cell={(props) => renderCustomButton(props.dataItem)}
          //   width={getColumnWidth(100)}
          // />
        );
      }else if(donationStatus === 'EXPIRED'){
        columns.push(
          <Column field="id" title="ID" locked={true} width={getColumnWidth(200)} filter={'numeric'} columnMenu={MyColumnMenu} />,
          <Column field="donationType" title="Tipo" width={getColumnWidth(200)} columnMenu={MyColumnMenu} />,
          <Column title="Período">
            <Column field="dataInicio" title="Data início" width={getColumnWidth(200)} filter={'date'} columnMenu={MyColumnMenu} />,
            <Column field="dataFim" title="Data final" width={getColumnWidth(200)} filter={'date'} columnMenu={MyColumnMenu} />
          </Column>,
          <Column title="Período canal alternativo">
            <Column field="dataInicioCanalAlternativo" title="Data início" width={getColumnWidth(200)} filter={'date'} columnMenu={MyColumnMenu} />,
            <Column field="dataFinalCanalAlternativo" title="Data final" width={getColumnWidth(200)} filter={'date'} columnMenu={MyColumnMenu} />
        </Column>,
        <Column field="reserva" title="reservas" width={getColumnWidth(150)} columnMenu={MyColumnMenu} />,
      //   <Column title="Reservas">
          
      //     <Column field="status" title="Estado" width={getColumnWidth(150)} columnMenu={MyColumnMenu} />,
      //     {/* <Column field="reservaexpiradas" title="Expiradas" width={getColumnWidth(150)} columnMenu={MyColumnMenu} />, */}
      // </Column>,
         <Column cell={CustomButtonCell2} locked={true} width={getColumnWidth(70)}/>,
         <Column cell={CustomButtonCell}  locked={true} width={getColumnWidth(70)}/>
          // <Column
          //   title="Ações"
          //   cell={(props) => renderCustomButton(props.dataItem)}
          //   width={getColumnWidth(100)}
          // />
        );
      }else if(donationStatus === 'CANCELLED'){
        columns.push(
          <Column field="id" title="ID" locked={true} width={getColumnWidth(200)} filter={'numeric'} columnMenu={MyColumnMenu} />,
          <Column field="donationType" title="Tipo" width={getColumnWidth(200)} columnMenu={MyColumnMenu} />,
          <Column title="Período">
            <Column field="dataInicio" title="Data início" width={getColumnWidth(200)} filter={'date'} columnMenu={MyColumnMenu} />,
            <Column field="dataFim" title="Data final" width={getColumnWidth(200)} filter={'date'} columnMenu={MyColumnMenu} />
          </Column>,
          <Column title="Período canal alternativo">
            <Column field="dataInicioCanalAlternativo" title="Data início" width={getColumnWidth(200)} filter={'date'} columnMenu={MyColumnMenu} />,
            <Column field="dataFinalCanalAlternativo" title="Data final" width={getColumnWidth(200)} filter={'date'} columnMenu={MyColumnMenu} />
        </Column>,
         <Column field="reserva" title="reservas" width={getColumnWidth(150)} columnMenu={MyColumnMenu} />,
      //   <Column title="Reservas">
      //     <Column field="reserva" title="Nº" width={getColumnWidth(150)} columnMenu={MyColumnMenu} />,
      //     <Column field="status" title="Estado" width={getColumnWidth(150)} columnMenu={MyColumnMenu} />,
      //     {/* <Column field="reservacanceladas" title="Canceladas" width={getColumnWidth(150)} columnMenu={MyColumnMenu} />, */}
      // </Column>,
        <Column cell={CustomButtonCell2} locked={true} width={getColumnWidth(70)}/>,
        <Column cell={CustomButtonCell}  locked={true} width={getColumnWidth(70)}/>
          // <Column
          //   title="Ações"
          //   cell={(props) => renderCustomButton(props.dataItem)}
          //   width={"100px"}
          // />
        );
      }else if(donationStatus === 'COLLECTED'){
        columns.push(
          <Column field="id" title="ID" locked={true} width={getColumnWidth(200)} filter={'numeric'} columnMenu={MyColumnMenu} />,
          <Column field="donationType" title="Tipo" width={getColumnWidth(200)} columnMenu={MyColumnMenu} />,
          <Column title="Período">
            <Column field="dataInicio" title="Data início" width={getColumnWidth(200)} filter={'date'} columnMenu={MyColumnMenu} />,
            <Column field="dataFim" title="Data final" width={getColumnWidth(200)} filter={'date'} columnMenu={MyColumnMenu} />
          </Column>,
          <Column title="Período canal alternativo">
            <Column field="dataInicioCanalAlternativo" title="Data início" width={getColumnWidth(200)} filter={'date'} columnMenu={MyColumnMenu} />,
            <Column field="dataFinalCanalAlternativo" title="Data final" width={getColumnWidth(200)} filter={'date'} columnMenu={MyColumnMenu} />
        </Column>,
         <Column field="reserva" title="reservas" width={getColumnWidth(150)} columnMenu={MyColumnMenu} />,
         <Column cell={CustomButtonCell2} locked={true} width={getColumnWidth(70)}/>,
         <Column cell={CustomButtonCell}  locked={true} width={getColumnWidth(70)}/>
          // <Column
          //   title="Ações"
          //   cell={(props) => renderCustomButton(props.dataItem)}
          //   width={"100px"}
          // />
        );
      }else{
        columns.push(
          <Column field="id" title="ID" locked={true} width={getColumnWidth(200)} filter={'numeric'} columnMenu={MyColumnMenu} />,
          <Column field="donationType" title="Tipo" width={getColumnWidth(200)} columnMenu={MyColumnMenu} />,
          <Column title="Período">
            <Column field="dataInicio" title="Data início" width={getColumnWidth(200)} filter={'date'} columnMenu={MyColumnMenu} />,
            <Column field="dataFim" title="Data final" width={getColumnWidth(200)} filter={'date'} columnMenu={MyColumnMenu} />
          </Column>,
          <Column field="reserva" title="Reservas" width={getColumnWidth(150)} columnMenu={MyColumnMenu} />,
          <Column cell={CustomButtonCell2} locked={true} width={getColumnWidth(70)}/>,
           <Column cell={CustomButtonCell}  locked={true} width={getColumnWidth(70)}/>
          // <Column
          //   title="Ações"
          //   cell={(props) => renderCustomButton(props.dataItem)}
          //   width={"100px"}
          // />
        );
      }
    
      return columns;
    }, [donationStatus]);
     ////// end colunas dinamicas /////
  return (
    <LocalizationProvider language="pt-PT" >
    <IntlProvider locale="pt">
    <div>
      
    {all &&   <Grid
    style={{ overflowX: 'auto' }}
    culture="pt-PT"
    // width={"100%"}
    resizable={true}
      data={result} 
      {...dataState}
        onDataStateChange={dataStateChange}
        sortable={true}
        pageable={true}
        pageSize={8}
        // groupable={true}
    >
      {columnsGrid}
    </Grid>
       
    }
    </div>
      </IntlProvider>
      </LocalizationProvider>
    // <>
    //   <Grid2 item xs={12} lg={2.5}>
    //     <Typography
    //       gutterBottom
    //       variant="subtitle1"
    //       fontFamily={"Sitka Heading"}
    //       fontWeight={fontWeightStyle}
    //     >
    //       {id}
    //     </Typography>
    //   </Grid2>
    //   <Grid2 item xs={12} lg={2.5}>
    //     <Typography
    //       variant="body2"
    //       gutterBottom
    //       fontFamily={"Poppins"}
    //       fontWeight={fontWeightStyle}
    //     >
    //       {donationType}
    //     </Typography>
    //   </Grid2>
    //   <Grid2 item xs={12} lg={5}>
    //     {matches && componentType !== ComponentType.DONATION_HEADER && (
    //       <Typography
    //         variant="body2"
    //         color={"text.primary"}
    //         fontFamily={"Poppins"}
    //         fontWeight={"600"}
    //       >
    //         {t("period")}
    //       </Typography>
    //     )}
    //     <Typography
    //       variant="body2"
    //       color={colorStyle}
    //       fontFamily={"Poppins"}
    //       fontWeight={fontWeightStyle}
    //     >
    //       {periodo}
    //     </Typography>
    //   </Grid2>
    //   <Grid2 item xs={12} lg={2}>
    //     {matches && componentType !== ComponentType.DONATION_HEADER && (
    //       <Typography
    //         variant="body2"
    //         color={"text.primary"}
    //         fontFamily={"Poppins"}
    //         fontWeight={"600"}
    //       >
    //         {t("reservation")}
    //       </Typography>
    //     )}
    //     <Typography
    //       variant="body2"
    //       color={colorStyle}
    //       sx={{ mx: 2 }}
    //       fontFamily={"Poppins"}
    //       fontWeight={fontWeightStyle}
    //     >
    //       {reserva}
    //     </Typography>
    //   </Grid2>
    // </>
  );
};

export default DonationDetail;
